import PageHeading from "Layout/AppMain/PageHeading";
import React, { Fragment, useEffect, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Button, CardFooter, Col, Input, Label, Row } from "reactstrap";
import Records from "./table";
import AppFooter from "Layout/AppFooter";
import { toast } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import Process from "../Process";
import { useNavigate } from "react-router";
import { useGetSchoolLists, useWeekstatenOverview } from "Api/Coordinator/Weekstaten";



const Default = () => {
    const [statusIds, setStatusIds] = useState("t:1;");
    const [schoolId, setSchoolId] = useState(-1);
    const [communityId, setCommunityId] = useState(-1);
    const [menuShow, setMenuShow] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [serachValue, setSerachValue] = useState("");
    const [pageSizeCount, setPageSizeCount] = useState(100);
    const pdfDownloading =
        JSON.parse(sessionStorage.getItem("pdfDownloading")) || false;
    const [alertMsg, setAlertMsg] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [processData, setProcessData] = useState({
        iCommunityId: [],
        iSchoolIds: [],
        iWeekstaatIds: [],
    });
    const [processResponse, setProcessResponse] = useState();
    const [overviewPage, setOverviewPage] = useState(true);

    const navigate = useNavigate();

    const { trigger: getSchoolListsTrigger } = useGetSchoolLists();

    const dataToSend =
        statusIds +
        "o:" +
        communityId +
        ";s:" +
        schoolId +
        ";&pageSize=" +
        pageSizeCount +
        "&pageNumber=" +
        pageNumber +
        "&search=" +
        (serachValue || "");

    const {
        data: overviewResponse,
        isLoading: showLoader,
        mutate,
    } = useWeekstatenOverview(dataToSend);

    const data = overviewResponse?.data || {};
    const totalPageCount = data?.pageCount || 0;
    const count = data?.totalCount


    useEffect(() => {
        if (pdfDownloading) {
            toast.success("Het genereren van uw PDF duurt ongeveer 5 minuten.");
            sessionStorage.setItem("pdfDownloading", false);
        }
    }, []);

    const searchHandler = (val) => {
        const delay = 1000;
        const timeoutId = setTimeout(() => {
            setPageNumber(1);
            setSerachValue(val);
        }, delay);

        return () => {
            clearTimeout(timeoutId);
        };
    };

    const getDataToSend = (event, id) => {
        setPageNumber(1);
        setStatusIds((prevText) => {
            const newStatusIds = prevText.split(";").filter((item) => item);
            if (event.target.checked) {
                if (!newStatusIds.includes(`t:${id}`)) {
                    newStatusIds.push(`t:${id}`);
                }
            } else {
                const index = newStatusIds.indexOf(`t:${id}`);
                if (index > -1) {
                    newStatusIds.splice(index, 1);
                }
            }
            return newStatusIds.join(";") + (newStatusIds.length > 0 ? ";" : "");
        });
    };

    const menuIsOpen = () => {
        if (menuShow === false) {
            setMenuShow(true);
        } else {
            setMenuShow(false);
        }
    };

    const handleNextProcess = () => {
        if (processData.iCommunityId.length === 0) {
            setShowAlert(true);
            setAlertMsg("Selecteer minimaal één weekafschrift.");
            return;
        }

        if (!processData.iCommunityId.every((value) => value === processData.iCommunityId[0])) {
            setShowAlert(true);
            setAlertMsg(
                "Weekstaten moeten per organisatie verwerkt worden. Selecteer scholen van één organisatie."
            );
            return;
        }

        const reqData = {
            ...processData,
            iCommunityId: processData.iCommunityId[0],
        };

        getSchoolListsTrigger({
            method: "post",
            data: reqData,
        })
            .then((response) => {
                if (response?.status === true) {
                    setOverviewPage(false);
                    setProcessResponse(response?.data);
                }
            })
            .catch(console.error);
    };

    const updateProcessData = (rowData, type) => {
        let id = [];

        if (type === "ADD_ALL") {
            id = rowData.map((item) => {
                return getCommunityId(item.vCommunityName);
            });
        } else if (type === "REMOVE_ALL") {
            id = [];
        } else {
            id = [getCommunityId(rowData.vCommunityName)];
        }

        if (type === "ADD") {
            setProcessData((prev) => {
                return {
                    iCommunityId: [...prev.iCommunityId, id[0]],
                    iSchoolIds: [...prev.iSchoolIds, rowData.iSchoolId],
                    iWeekstaatIds: [...prev.iWeekstaatIds, rowData.id],
                };
            });
        } else if (type === "REMOVE") {
            setProcessData((prev) => {
                const idToRemove = rowData.iSchoolId;
                const indexToRemove = prev.iSchoolIds.indexOf(idToRemove);
                const commId = id[0];
                const indexCommId = prev.iCommunityId.indexOf(commId);

                return {
                    iCommunityId:
                        indexToRemove !== -1
                            ? [
                                ...prev.iCommunityId.slice(0, indexCommId),
                                ...prev.iCommunityId.slice(indexCommId + 1),
                            ]
                            : prev.iCommunityId,
                    iSchoolIds:
                        indexToRemove !== -1
                            ? [
                                ...prev.iSchoolIds.slice(0, indexToRemove),
                                ...prev.iSchoolIds.slice(indexToRemove + 1),
                            ]
                            : prev.iSchoolIds,
                    iWeekstaatIds: prev.iWeekstaatIds.filter(
                        (item) => item !== rowData.id
                    ),
                };
            });
        } else if (type === "ADD_ALL") {
            setProcessData({
                iCommunityId: id,
                iSchoolIds: rowData.map((item) => item.iSchoolId),
                iWeekstaatIds: rowData.map((item) => item.id),
            });
        } else if (type === "REMOVE_ALL") {
            setProcessData({
                iCommunityId: id,
                iSchoolIds: [],
                iWeekstaatIds: [],
            });
        } else if (type === "ID_CLICK") {
            navigate(`/weekstaten/${rowData.id}`, {
                state: {
                    data: {
                        wid: rowData.wid,
                        iSchoolId: rowData.iSchoolId,
                        iWeekstaatId: rowData.id,
                    },
                },
            });
        } else return;
    };

    function getCommunityId(communityName) {
        return data?.communityList?.filter(
            (item) => item.name === communityName
        )[0]?.iCommunityId;
    }

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <Fragment>
                    {overviewPage && (
                        <div className="chat-layout-wrapper">
                            <div className="app-inner-layout chat-layout">
                                <Row className="app-inner-layout__wrapper mx-0 g-0">
                                    <Col md="12" lg="12">
                                        <Records
                                            data={data}
                                            showLoader={showLoader}
                                            pageNumber={pageNumber}
                                            setPageNumber={setPageNumber}
                                            totalPageCount={totalPageCount}
                                            pageSizeCount={pageSizeCount}
                                            setPageSizeCount={setPageSizeCount}
                                            processData={processData}
                                            searchHandler={searchHandler}
                                            processDataHandler={updateProcessData}
                                            count={count}
                                        />
                                    </Col>
                                </Row>
                            </div>

                            <div className="chat-layout-footer">
                                <CardFooter className="d-block text-center d-flex chat-layout-footer__inner footer_inner_margin">
                                    <div className=" d-flex w-100 ">
                                        <Row className="mx-0 align-items-center w-100">

                                            {/* Bestuur */}
                                            <Col md="1">
                                                <select
                                                    className="form-select w-auto"
                                                    value={communityId}
                                                    onChange={(event) => {
                                                        setSchoolId(-1);
                                                        setCommunityId(event.target.value);
                                                        setPageNumber(1);
                                                    }}
                                                >
                                                    <option value="-1">Alle besturen</option>
                                                    {data?.communityList?.map((key) => (
                                                        <option
                                                            key={key.iCommunityId}
                                                            value={key.iCommunityId}
                                                        >
                                                            {key.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </Col>

                                            {/* School */}
                                            <Col md="1" className='me-4 ms-4'>
                                                <select
                                                    className="form-select w-auto "
                                                    value={schoolId}
                                                    onChange={(event) => {
                                                        setSchoolId(event.target.value);
                                                        setPageNumber(1);
                                                    }}
                                                >
                                                    <option value="-1">Alle Scholen</option>
                                                    {data?.schoolList?.map((key) => (
                                                        <option
                                                            key={key.iSchoolId}
                                                            value={key.iSchoolId}
                                                        >
                                                            {key.vSchoolName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </Col>
                                            <Col md="1" style={{ width: "10px" }}>

                                                <div className="status-filter-divider"></div>
                                            </Col>


                                            {/* Status checkboxes */}
                                            <Col md="5" className='me-4'>
                                                <div className="checbox-border d-flex align-items-center">

                                                    <div className="custom-checkbox d-flex align-items-center me-4">
                                                        <Label className="mb-0 me-2">
                                                            Openstaand ({data?.openStaandCount || 0})
                                                        </Label>
                                                        <Input
                                                            type="checkbox"
                                                            onChange={(event) => getDataToSend(event, 1)}
                                                            defaultChecked
                                                        />
                                                    </div>

                                                    <div className="custom-checkbox d-flex align-items-center me-4">
                                                        <Label className="mb-0 me-2">
                                                            Goedgekeurd
                                                        </Label>
                                                        <Input
                                                            type="checkbox"
                                                            onChange={(event) => getDataToSend(event, 2)}
                                                        />
                                                    </div>

                                                    <div className="custom-checkbox d-flex align-items-center me-4">
                                                        <Label className="mb-0 me-2">
                                                            Afgekeurd
                                                        </Label>
                                                        <Input
                                                            type="checkbox"
                                                            onChange={(event) => getDataToSend(event, 3)}
                                                        />
                                                    </div>

                                                    <div className="custom-checkbox d-flex align-items-center">
                                                        <Label className="mb-0 me-2">
                                                            Afgesloten
                                                        </Label>
                                                        <Input
                                                            type="checkbox"
                                                            onChange={(event) => getDataToSend(event, 4)}
                                                        />
                                                    </div>

                                                </div>
                                            </Col>

                                            {/* Button */}
                                            <Col md="4" className="d-flex justify-content-end text-align-end">
                                                <Button
                                                    className="d-flex align-items-center btn-color-style opslaan-btn"
                                                    size="sm"
                                                    outline
                                                    color="primary"
                                                    onClick={handleNextProcess}
                                                >
                                                    Verwerken
                                                </Button>
                                            </Col>

                                        </Row>


                                    </div>
                                </CardFooter>
                            </div>
                        </div>
                    )}

                    {!overviewPage && (
                        <Process
                            processData={processData}
                            data={processResponse}
                            setOverviewPage={setOverviewPage}
                            setProcessData={setProcessData}
                        />
                    )}

                    <SweetAlert
                        title={alertMsg}
                        show={showAlert}
                        type="warning"
                        onConfirm={() => setShowAlert(false)}
                        confirmBtnText="Ok"
                    />
                </Fragment>
            </TransitionOnLoad>
            {/* <AppFooter /> */}
        </Fragment>
    );
};

export default Default;